<template>
  <div class="main-layout">
    <div class="main-layout__head main-layout__head_pb24">
      <h2 class="main-title">Materialien</h2>
    </div>

    <breadcrumbs
      v-if="showBreadcrumbs"
      :breadcrumbs="$route.meta.breadcrumbs"
    />

    <materials-list :list="list" v-if="showList" :id="id" />

    <!--add modal material start-->
    <modal :show="addModal" :outside="false" @close="toggleModal">
      <add-material
        :id="id"
        :materialId="materialId"
        @toggleAddModal="toggleModal"
      />
    </modal>
    <!--add modal material end-->

    <!--delete modal material start-->
    <modal
      :show="deleteModal"
      :showBtn="false"
      :outside="false"
      :dark="true"
      @close="closeDeleteModal"
    >
      <delete-modal
        :title="$t('global.areUsure')"
        @cancel="closeDeleteModal"
        @next="removeAction"
      />
    </modal>
    <!--delete modal material end-->

    <add-btn v-if="$guard('write', 'Materials')" @onClick="openModal" />
  </div>
</template>

<script>
import addMaterial from '@/components/modals/materials/addMaterial'
import materialsList from '@/components/lists/materials/materialsList'
import addBtn from '@/components/controls/addBtn'

import breadcrumbs from '@/components/controls/breadcrumbs'
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
    props: ['id', 'serviceTitle'],
    components: {
        addMaterial,
        materialsList,
        breadcrumbs,
        addBtn,
    },
    data() {
        return {
            showList: false,
            materialId: null,
            showBreadcrumbs: false,
            scrolledToBottom: false,
            toBottom: false,
            orderBy: 'originalName',
            sortBy: 'asc',
        }
    },
    computed: {
        ...mapGetters({
            addNewModal: 'materials/addNewModal',
            list: 'materials/getMaterials',
            getActiveMaterial: 'materials/getActiveMaterial',
            getServiceData: 'serviceSelfData',
            getModalType: 'materials/getModalType',

            deleteModal: 'materials/deleteModalGetters',
            addModal: 'materials/addModalGetters',
            materialsDeleteId: 'materials/materialsDeleteId',
        }),
    },
    watch: {
        async addModal(v) {
            if (v === false) this.clearMaterial()

            await this.fetchMaterialIcons()
        },
        list(v) {
            if (v.length > 0) this.showList = true
        },
    },
    methods: {
        ...mapActions({
            fetch: 'materials/fetch',
            initServiceData: 'getServiceData',
            fetchMaterialIcons: 'materials/fetchMaterialIcons',
            remove: 'materials/del',
            requestForDelete: 'deleteControl/requestForDelete',
        }),
        ...mapMutations({
            clear: 'materials/clear',
            clearMaterial: 'materials/clearMaterial',
            updateModalType: 'materials/updateModalType',
            setActiveMaterial: 'materials/setActiveMaterial',
            toggleModal: 'materials/toggleModal',
            toggleDeleteModal: 'materials/toggleDeleteModal',
        }),
        openModal() {
            this.toggleModal()
            this.updateModalType('add')
        },
        toggleAddModal(type, id) {
            this.materialId = id
            this.$emit('clearErrors')
            if (type === 'edit') {
                this.loadEditModal(id)
                this.updateModalType('edit')
            } else this.updateModalType('add')
            this.toggleModal()
        },
        closeDeleteModal(id = null) {
            this.materialId = id
            this.toggleDeleteModal()
        },
        async removeAction() {
            if (!this.$guard('delete', 'Materials')) {
                this.requestForDelete({
                    id: this.materialsDeleteId,
                    type: 'materials',
                })

                await this.fetch({ id: this.id, page: 'materials' })
                this.closeDeleteModal()
                return
            }

            this.remove({ serviceId: this.id })
        },
    },
    async beforeMount() {
        await this.initServiceData(this.$route.params.id)
        await this.setActiveMaterial(this.getServiceData.title)
        await this.$route.meta.breadcrumbs.push({
            name: this.getServiceData.title,
        })
        this.showBreadcrumbs = true
    },
    async mounted() {
        await this.fetch({ id: this.id, page: 'materials' })
        if (this.list.length > 0) this.showList = true
    },
    beforeRouteLeave(to, from, next) {
        this.$route.meta.breadcrumbs = this.$route.meta.breadcrumbs.slice(0, -1)
        this.clear()
        next()
    },
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";

.wrapper {
  width: calc(100% - 120px);
  height: 100%;
  padding: 94px 60px 40px;
  overflow: hidden;
}

.material {
  border-radius: 8px;
  background-color: #ffffff;
  width: 100%;
  height: calc(100% - 86px);
  position: absolute;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  top: 0;
  left: 0;
  &__wrapper {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    padding-bottom: 24px;
    box-sizing: border-box;
  }
  &__add {
    position: fixed;
    right: 25px;
    bottom: 25px;
    display: flex;
    align-items: flex-end;
    &-text {
      color: #4d4d4d;
      font-size: 12px;
      margin-right: 16px;
      font-family: $fontMedium;
    }
    &-button {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      background-color: $primaryColor;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      background-image: url("/images/icon/add.svg");
      background-position: center;
      background-size: 20px;
      background-repeat: no-repeat;
      transition: 0.5s;
      cursor: pointer;
      &:hover {
        background-color: $secondColor;
      }
    }
  }
}
</style>
